import { Calilio } from '@/assets/static/icons';
import { useauthMeQuery } from '@/types/generated/graphql';
import { AppPrimaryButton } from '@components/form/button/app-primary-button';
import { cacheOnly } from '@shared/constants';
import { useUserGuideStore } from '@shared/store/user-guide.store';
import { capitalize } from '@shared/utils/capitalize';
import { Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function UserGuideWelcomeModalView() {
  const { t } = useTranslation();
  const { startTour } = useUserGuideStore();
  const { data } = useauthMeQuery(cacheOnly);
  const tourGuideEnabled = data?.authMe?.data?.user?.tourGuideEnabled;
  const [dismissed, setDismissed] = useState(false);

  function handleStartExploring() {
    setDismissed(true);
    startTour(0);
  }

  return (
    <Modal
      open={Boolean(tourGuideEnabled) && !dismissed}
      centered
      footer={null}
      closable={false}
      classNames={{ content: 'max-w-[420px]' }}
    >
      <div className="flex flex-col items-center text-center py-2">
        <Calilio className="size-14 mb-4" />
        <p className="text-lg font-semibold text-text-900 mb-3">{t('welcome_to_calilio')}</p>
        <p className="text-sm text-text-600 mb-3">{t('welcome_modal_description_1')}</p>
        <p className="text-sm text-text-600 mb-5">{t('welcome_modal_description_2')}</p>
        <AppPrimaryButton onClick={handleStartExploring}>{capitalize(t('start_exploring'))}</AppPrimaryButton>
      </div>
    </Modal>
  );
}
